import React from 'react';
import CreateCloudfrontUrl from '/src/services/CreateCloudfrontUrl';
import './style.css';
import LabAnalysisOverviewPayoff from '../LabAnalysisOverview/Payoff/LabAnalysisOverviewPayoff';
import { CurlyBraceDivider } from '/src/Components/CurlyBraceDivider/CurlyBraceDivider';

const LabAnalysisPayoff = ({
    simulatorData
}) => {

    // Get the payoff values for each type

    // Dollars and percentage objects which are keyed by type
    const totalPayoffs10YearDollars = simulatorData?.payback?.tenYearTotals || {}
    const totalPayoffs10YearPercent = simulatorData?.payback?.pctByType || {}

    // Capital Freed
    const capitalFreedPaybackDollars = totalPayoffs10YearDollars.capital_freed || 0
    const capitalFreedPaybackPercent = totalPayoffs10YearPercent.capital_freed * 100 || 0

    // Opex
    const opexPaybackDollars = totalPayoffs10YearDollars.opex || 0
    const opexPaybackPercent = totalPayoffs10YearPercent.opex * 100 || 0

    // Market Value
    const marketValuePaybackDollars = totalPayoffs10YearDollars.property_value_upside || 0
    const marketValuePaybackPercent = totalPayoffs10YearPercent.property_value_upside * 100 || 0




    const introText = `This is how these improvements benefit you over time. Note the individual contributions of each project on the left.`
    const conclusionText = "If you look at the projects you can see how much each is contribution to these totals!"

    const numProjects = simulatorData?.numProjects || 1

    const impactAcrossTimeOptions = [
        {
            id: 1,
            icon: 'broken-home-green.png',
            timeframe: 'Sudden',
            title: 'Unforeseen Fixes',
            description: "Costs you may not have budgeted for.",
            benefitText: "Costs Avoided",
            benefitsDollar: capitalFreedPaybackDollars,
            benefitsPercent: capitalFreedPaybackPercent
        },
        {
            id: 2,
            icon: 'home_bills.png',
            timeframe: 'Recurring',
            title: 'General Expenses',
            description: 'Think insurance, maintenance, taxes, utilities etc.',
            benefitText: "Bill Savings",
            benefitsDollar: opexPaybackDollars,
            benefitsPercent: opexPaybackPercent
        },
        {
            id: 3,
            icon: 'home-ltv-icon.png',
            timeframe: 'Long-Term',
            title: 'Market Value',
            description: 'What happens when you go to sell the property?',
            benefitText: "Value Increase",
            benefitsDollar: marketValuePaybackDollars,
            benefitsPercent: marketValuePaybackPercent
        }
    ]

    return (
        <div className="lab-analysis-section-content-container">
            <h2 className="lab-analysis-section-title">Financial Benefit To You</h2>
            {/* <h2 className="lab-analysis-section-title">Payoff From Project{ numProjects > 1 ? 's' : '' }</h2> */}
            <div className="lab-analysis-financial-data-container">

                <LabAnalysisOverviewPayoff simulatorData={simulatorData} />
                <CurlyBraceDivider color='green'/>
                <div className="lab-analysis-payoff-options-container">
                    {impactAcrossTimeOptions.map((option, index) => (
                        <div key={index} className="lab-analysis-payoff-option">
                            <div className="lab-analysis-payoff-option-timeframe-container">
                                <span>{option.timeframe}</span>
                            </div>
                            <div className="lab-analysis-payoff-option-type-details-wrapper">
                                <div className="lab-analysis-payoff-option-icon-wrapper">
                                    <img src={CreateCloudfrontUrl(option.icon)} alt={option.title} />
                                </div>
                                <span className="lab-analysis-payoff-option-title">{option.title}</span>
                                {/* <span className="lab-analysis-payoff-option-description text-align-center">{option.description}</span> */}
                            </div>
                            <div className="lab-analysis-payoff-option-benefits-wrapper">
                                <span className="lab-analysis-payoff-option-benefit-text">{option.benefitText}</span>
                                <span className="lab-analysis-payoff-option-benefit-dollar">
                                    ${Math.round(option.benefitsDollar).toLocaleString()}
                                </span>
                                <span className="lab-analysis-payoff-option-benefit-percent">
                                    {Math.round(option.benefitsPercent)}% of total payoff
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <p className="lab-analysis-section-intro-text text-align-center" dangerouslySetInnerHTML={{ __html: introText }} />
            {/* <p className="lab-analysis-payoff-conclusion-text text-align-center" dangerouslySetInnerHTML={{ __html: conclusionText }} /> */}
        </div>
    )
}

export default LabAnalysisPayoff;